import { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";

const CollapsibleSection = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return (
    <div className="border border-slate-700 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-3 bg-slate-800 hover:bg-slate-700 transition-colors"
      >
        <span className="font-medium text-slate-300 text-sm">{title}</span>
        {isOpen ? (
          <ChevronDown className="w-4 h-4 text-slate-400" />
        ) : (
          <ChevronRight className="w-4 h-4 text-slate-400" />
        )}
      </button>
      {isOpen && (
        <div className="p-4 bg-slate-900 text-sm">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
